<template>
  <div>
    <!-- filtros de fechas -->
    <v-row class="mb-4" style="margin:auto; max-width: 800px;">
      <v-col cols="12" md="6">
        <s-date label="Fecha Inicio" v-model="startDate" />
      </v-col>
      <v-col cols="12" md="6">
        <s-date label="Fecha Fin" v-model="endDate" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="12" md="12">
        <cacke-report
          :rows="data"
          :headers="headers"
          value-field="CANTIDAD"
          storage-key="CackeRepPorts"
          :loading-prop="loading"
          :key="chartKey"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import CackeReport from "./Charts/CakeReport.vue";
import _TasReportChartService from "../../../services/Technicalassistance/TasReportCharts/TasReportChartService";

export default {
  components: {
    CackeReport,
  },
  data: () => ({
    chartKey: 0,
    headers: [],
    data: [],
    fieldKey: "CANTIDAD",
    storageKey: "HarvestJabaQuantity",
    loading: false,
    //primer dia del mes y ultimo dia del mes
    startDate: null,
    endDate: null,
  }),
  created() {
    this.loadData();
  },
  watch: {
    startDate() {
      this.loadData();
    },
    endDate() {
      this.loadData();
    },
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        // Simular llamada a servicio
        var response = await _TasReportChartService.GetHarvestJabaQuantityReport(
          {
            StartDate: this.startDate,
            EndDate: this.endDate,
          },
          this.$fun.getUserID()
        );

        this.data = response.data;
        //sacar los headers del primer objeto solo sacarlos en un array los encabezados
        this.headers = [
          "NAVE",
          "ZONA",
          "SUPERVISOR",
          "CULTIVO_VAR",
          "TIPO_CULT",
          "TIPO_CARGA",
          "CANTIDAD",
        ];
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.loading = false;
        this.chartKey++;
      }
    },
  },
};
</script>
